import { connect } from "react-redux";
import {
  generateReports,
  getFdesMetaDataForCalculRow,
} from "../../fdes/actions";
import FolderCalculsTable from "../components/FolderCalculsTable";
import {
  deleteCalcul,
  duplicateCalcul,
  restoreArchivedCalcul,
  sendXmlToEDEC,
  setCalculArchived,
  updateCalculAttributes,
} from "../../calcul/actions";
import {
  changeFolderCalculsSort,
  clearFolderInfos,
  loadFolderCalculs,
  manageCalculsFolders,
} from "../actions";

export default connect(
  (state) => ({
    user: state.user.informations,
    folderCalculs: state.folders.folderCalculs,
    folderCalculsSort: state.folders.folderCalculsSort,
    isGeneratingReports: state.loader.isGeneratingReports,
    generatingReportsIds: state.loader.generatingReportsIds,
    aggregatedFamilyProducts: state.familyProduct.aggregatedFamilyProducts,
    localEDECIntegration: state.configurator.localEDECIntegration,
    folders: state.folders.folders,
    tableScrollDisabled: state.loader.tableScrollDisabled,
    calculsColumns: state.user.informations.calculsColumns,
  }),
  (dispatch) => ({
    changeFolderCalculsSort: (sort, folderId) => {
      dispatch(changeFolderCalculsSort(sort, folderId));
    },
    generateReports: (filesToGenerate, userFdesId, folderId) => {
      dispatch(generateReports(filesToGenerate, userFdesId, folderId));
    },
    duplicateCalcul: (calculId) => {
      dispatch(duplicateCalcul(calculId));
    },
    getFdesMetadataCalculRow: (fdesId) => {
      return new Promise((resolve, reject) => {
        dispatch(getFdesMetaDataForCalculRow(fdesId, resolve, reject));
      });
    },
    sendXmlToEDEC: (values) => {
      dispatch(sendXmlToEDEC(values));
    },
    loadFolderCalculs: (folderId) => {
      dispatch(loadFolderCalculs(folderId));
    },
    manageCalculsFolders: (data) => {
      dispatch(manageCalculsFolders(data));
    },
    setCalculArchived: (calculId, folderId) => {
      dispatch(setCalculArchived(calculId, folderId));
    },
    deleteCalcul: (calculId) => {
      dispatch(deleteCalcul(calculId));
    },
    restoreArchivedCalcul: (calculId, folderId) => {
      dispatch(restoreArchivedCalcul(calculId, folderId));
    },
    updateCalculAttributes: (calculId, attributes) => {
      dispatch(updateCalculAttributes(calculId, attributes));
    },
    clearFolderInfos: () => {
      dispatch(clearFolderInfos());
    },
  }),
)(FolderCalculsTable);
